import src from "IMAGE";
export default { src, width: 54, height: 125, blurWidth: 0, blurHeight: 0};
